module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/53.d2e6ed22.png";